import { useEffect, useState } from "react";

import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { ModalCoreBase } from "src/Pages/components/ModalCoreBase/ModalCoreBase";
import { DetailsSubscriptions } from "./Steps/DetailsSubscriptions";
import { PlansSubscriptions } from "./Steps/PlansSubscriptions";
import { CardCreditSubscription } from "./Steps/Components/CardCreditSubscription/CardCreditSubscription";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { SubscriptionSuccess } from "./Steps/SubscriptionSuccess";
import { SubscriptionFailure } from "./Steps/SubscriptionFailure";
import { api } from "src/shared/setup/API/api";

export interface IPlanSubscriptions {
  id: string;
  title: string;
  amount: number;
  recommended: boolean;
  featuresCommon: string[];
  features?: string[];
  type: "PRO" | "LITE";
  featuresPro?: string[];
}

export const ModalSubscriptions = () => {
  const { userPerfil } = useAuthContext();
  const {
    openModalSubscriptions,
    handleOpenModalSubscriptions,
    handleCloseModalSubscriptions,
  } = useLayoutMainContext();

  const [listPlans, setListPlans] = useState<IPlanSubscriptions[]>([]);
  const [step, setStep] = useState(1);

  const [planSelected, setPlanSelected] = useState<IPlanSubscriptions>(
    listPlans.find((plan) => plan.recommended) || listPlans[0]
  );

  useEffect(() => {
    api.get(`/checkout/plans-pack`).then((res) => {
      setListPlans(res.data.data);
    });
  }, []);

  useEffect(() => {
    if (userPerfil && !userPerfil?.subscription?.id) {
      handleOpenModalSubscriptions();
    }
  }, [userPerfil]);

  useEffect(() => {
    if (listPlans.length > 0) {
      setPlanSelected(
        listPlans.find((plan) => plan.recommended) || listPlans[0]
      );
    }
  }, [listPlans]);

  return (
    <ModalCoreBase
      open={openModalSubscriptions}
      sx={{
        width: "950px",
        maxWidth: {
          xs: "92%",
          md: "95%",
        },
        height: {
          xs: "92%",
          md: "610px",
        },
        overflowY: "auto",
        p: 0,
      }}
    >
      <>
        {step === 1 && <DetailsSubscriptions setStep={setStep} />}

        {step === 2 && (
          <PlansSubscriptions
            setStep={setStep}
            planSelected={planSelected}
            setPlanSelected={setPlanSelected}
            listPlans={listPlans}
          />
        )}

        {step === 3 && (
          <CardCreditSubscription
            setStep={setStep}
            planSelected={planSelected}
          />
        )}

        {step === 4 && (
          <SubscriptionSuccess
            planSelected={planSelected}
            setOpenModal={handleCloseModalSubscriptions}
          />
        )}

        {step === 5 && (
          <SubscriptionFailure
            setStep={setStep}
            planSelected={planSelected}
            setOpenModal={handleCloseModalSubscriptions}
          />
        )}
      </>
    </ModalCoreBase>
  );
};
